import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';
import { TOPIC_INSIGHTS_ROUTE, type TopicInsightsReply, type TopicInsightsRequest } from '@/shared/assist/TopicInsightsContract';

/** Calls the BFF topic-insights route over the authenticated fetch (CSRF header + session cookie). */
export async function fetchTopicInsights(request: TopicInsightsRequest): Promise<TopicInsightsReply> {
    const response = await authenticatedFetch(TOPIC_INSIGHTS_ROUTE, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(request),
    });
    if (!response.ok) {
        throw new Error(`Topic insights request failed (${response.status})`);
    }
    return (await response.json()) as TopicInsightsReply;
}
